import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { authHeaders, forceRelogin } from './api';

// Every same-origin /api call carries the login token; an expired session goes back to login
const origFetch = window.fetch.bind(window);
window.fetch = async (input, init = {}) => {
  const url = typeof input === 'string' ? input : input.url;
  const isApi = url.startsWith('/api/') || url.startsWith(window.location.origin + '/api/');
  if (!isApi) return origFetch(input, init);
  const headers = { ...authHeaders(), ...(init.headers || {}) };
  const res = await origFetch(input, { ...init, headers });
  if (res.status === 401 && !url.includes('/users/login')) {
    const body = await res.clone().json().catch(() => ({}));
    if (body.error === 'auth_required') forceRelogin();
  }
  return res;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
